<template>
	<div
		class="app-side-nav"
		:class="{'app-side-nav--expanded' : expanded}"
	>
		<img v-show="expanded" src="@/assets/img/ic-logo.png" class="app-side-nav__logo">
		<img v-show="!expanded" src="@/assets/img/ic-logo-short.png" class="app-side-nav__logo">

		<div class="app-side-nav__divider"></div>

		<div class="app-side-nav__links">
			<a
				class="link"
				:class="{'link--active' : link.name === current.name}"
				v-for="(link, index) of links"
				:key="index"
				@click="$emit('click', link)"
			>
                <svg v-if="link.name === 'SongsList'" :key="link.name" class="link__icon" xmlns="http://www.w3.org/2000/svg" width="18" height="17.997" viewBox="0 0 18 17.997"><g transform="translate(-3.997 -5)"><g transform="translate(3.997 5)"><path class="a" d="M18.4,5h-6A3.6,3.6,0,0,0,8.8,8.6v9.012a2.994,2.994,0,1,0-1.342,5.351A3.233,3.233,0,0,0,10,19.856V8.6H20.8v9.012a2.994,2.994,0,1,0-1.342,5.351A3.233,3.233,0,0,0,22,19.856V8.6A3.6,3.6,0,0,0,18.4,5Z" transform="translate(-3.997 -5)"/></g></g></svg>
                <svg v-else-if="link.name === 'SubscribersList'" :key="link.name" class="link__icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path class="a" d="M13.529,11.252a3.357,3.357,0,0,0,.9-2.25,3.4,3.4,0,1,0-6.8,0,3.357,3.357,0,0,0,.9,2.25A5.346,5.346,0,0,0,5.6,15.4a.905.905,0,1,0,1.8.2,3.6,3.6,0,0,1,7.146,0,.9.9,0,0,0,.954.8h.1a.9.9,0,0,0,.792-.99,5.346,5.346,0,0,0-2.862-4.158ZM11,10.6A1.6,1.6,0,1,1,12.6,9,1.6,1.6,0,0,1,11,10.6ZM17.3,2H4.7A2.7,2.7,0,0,0,2,4.7V17.3A2.7,2.7,0,0,0,4.7,20H17.3A2.7,2.7,0,0,0,20,17.3V4.7A2.7,2.7,0,0,0,17.3,2Zm.9,15.3a.9.9,0,0,1-.9.9H4.7a.9.9,0,0,1-.9-.9V4.7a.9.9,0,0,1,.9-.9H17.3a.9.9,0,0,1,.9.9Z" transform="translate(-2 -2)"/></svg>
				<span class="link__text" v-show="expanded">
					{{ link.text }}
				</span>
			</a>
		</div>

		<div
			class="app-side-nav__toggle"
			@click="expanded = !expanded"
		>
			<svg
				v-show="expanded"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 20 20"
			>
				<path
					fill="#778395"
					d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM8,20H4V4H8Zm12,0H10V4H20Z"
					transform="translate(-2 -2)"
				/>
			</svg>

			<svg
				v-show="!expanded"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 20 20"
			>
				<path
					fill="#778395"
					d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM8,20H4V4H8Zm12,0H10V4H20Z"
					transform="translate(-2 -2)"
				/>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		links: {
			type: Array,
			required: true
		},

		current: { default: null }
	},

	data () {
		return {
			expanded: true,
			language: '',
			languages: [
				{ text: 'English', icon: '' },
				{ text: 'Japanese', icon: '' }
			]
		}
	},

	mounted () {
		this.setDefaultLanguage()
	},

	methods: {
		selectLanguage (lang) {
			if (!lang) this.setDefaultLanguage()
			this.$emit('change-language', this.languages)
		},

		setDefaultLanguage () {
			this.language = this.languages[0]
		}
	}
}
</script>

<style lang="scss" scoped>
.app-side-nav {
	box-shadow: 0 0 3px $default-light;
	height: 100%;
	display: flex;
	flex-direction: column;

	&__logo {
		margin: 1.5em auto;
		width: 30px;
	}

	&__divider {
		width: 50%;
		margin: 3em auto;
		border-top: 1px solid $default-light;
	}

	&__links {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
        user-select: none;

		.link {
			padding: .8em 2em;
			display: flex;
            align-items: center;
			list-style: none;
			cursor: pointer;
            color: $default;

			&__icon { width: 1em; fill: $default; }
            &__text {
                 margin-left: .5em;
                 color: #778395;
                font-family: 'Quicksand', sans-serif;
                font-weight: 600;
             }

			&:hover, &--active {
				.link__text { color: $primary; }
				.link__icon path { fill: $primary; }
			}
		}
	}

	&__toggle {
		margin: 30px auto;
		cursor: pointer;

		svg {
			width: 15px;
			height: 15px;
		}

		&:hover svg path {
			fill: $primary;
		}
	}

	&__language {
		margin: 2em auto;

		.icon {
			width: 20px;
			min-height: 1em;
			background-color: #eee;
		}

		::v-deep .app-dropdown {
			&__toggle {
				border: none;
				padding: 0;
			}

			&__arrow {
				display: none;
			}
		}
	}

	&--expanded &__logo {
		width: 100px;
	}

	&--expanded &__toggle { margin: 30px 2em; }
	&--expanded &__language { margin: 2em; }
}
</style>
